/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const deletedLogMaintenance = /* GraphQL */ `
  subscription DeletedLogMaintenance {
    deletedLogMaintenance {
      lm_status_kb
    }
  }
`;
export const insertedLogMaintenance = /* GraphQL */ `
  subscription InsertedLogMaintenance {
    insertedLogMaintenance {
      lm_start_time
      lm_start_user_nm
      lm_status_kb
    }
  }
`;
